import { Ng1StateDeclaration } from "@uirouter/angularjs";

export const pluginListState: Ng1StateDeclaration = {
  name: ".pluginList",
  url: "plugins/",
  component: "pluginList",
};

export const pluginSettingsState: Ng1StateDeclaration = {
  name: ".pluginSettings",
  url: "plugins/:pluginId/",
  params: {
    pluginId: null,
  },
  data: {
    pageTitle: true,
  },
  component: "pluginSettings",
  // componentBindingToStateParamMap: {
  //   pluginId: "pluginId",
  // },
};
